import Chip from '@mui/material/Chip';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import type { JSX } from 'react';
import { IsoWeekday } from 'services/api/invoiceNotification/types';

import {
  ALL_DAYS,
  formatWeekday,
  IntlByKey,
  isEveryDay,
  isWeekdays,
  isWeekend,
  WEEKDAYS,
  WEEKEND_DAYS,
} from './summarySchedule';
import { ErrorText, Row, Section, SectionLabel } from './SummaryScheduleDialog.style';

interface DailyScheduleFieldsProps {
  days: IsoWeekday[];
  locale: string;
  scheduleIntl: IntlByKey;
  onChange: (days: IsoWeekday[]) => void;
}

export const DailyScheduleFields = ({
  days,
  locale,
  scheduleIntl,
  onChange,
}: DailyScheduleFieldsProps): JSX.Element => {
  const dayPresets = [
    { key: 'every-day', days: ALL_DAYS, isActive: isEveryDay(days) },
    { key: 'weekdays', days: WEEKDAYS, isActive: isWeekdays(days) },
    { key: 'weekends', days: WEEKEND_DAYS, isActive: isWeekend(days) },
  ];

  return (
    <Section>
      <SectionLabel>{scheduleIntl('days')}</SectionLabel>
      <Row>
        {dayPresets.map((preset) => (
          <Chip
            key={preset.key}
            size="small"
            label={scheduleIntl(preset.key)}
            color={preset.isActive ? 'primary' : 'default'}
            variant={preset.isActive ? 'filled' : 'outlined'}
            onClick={() => onChange(preset.days)}
          />
        ))}
      </Row>
      <ToggleButtonGroup
        size="small"
        color="primary"
        value={days}
        onChange={(_, selectedDays: IsoWeekday[]) => onChange(selectedDays)}
      >
        {ALL_DAYS.map((day) => (
          <ToggleButton key={day} value={day} aria-label={formatWeekday(day, locale, 'long')}>
            {formatWeekday(day, locale, 'short')}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {days.length === 0 && <ErrorText>{scheduleIntl('days-required')}</ErrorText>}
    </Section>
  );
};
